import { render, staticRenderFns } from "./ProductByFulfillmentCSide.vue?vue&type=template&id=63ff3546"
import script from "./ProductByFulfillmentCSide.vue?vue&type=script&lang=js"
export * from "./ProductByFulfillmentCSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports